module.exports = __webpack_public_path__ + "static/img/batch-delivery.16fe4dfb.png";